import React from "react";

const EnergyResourcesIcon = ({ size = 20, className }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          strokeWidth={1.5}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.54 11.515A7.494 7.494 0 0 0 9.89 17.5a7.505 7.505 0 0 0 7.342-5.963M17.247 8.545A7.494 7.494 0 0 0 9.889 2.5c-3.622 0-6.645 2.573-7.35 5.985"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m14.871 8.146 3.027.981.981-3.027M5.164 12.06 2.2 10.904 1.044 13.87"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M7.777 10.982H8.94v2.959c0 .69.343.83.76.312l2.85-3.534c.35-.431.203-.788-.327-.788h-1.164V6.972c0-.69-.342-.83-.76-.312l-2.85 3.534c-.346.435-.2.788.328.788"
        />
      </svg>
    </span>
  );
};

export default EnergyResourcesIcon;
